module.exports = "/_next/static/images/f271ee91582a2ef03e0a14011dfa07b7-contract.png";